import { KeyRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * The signed-in name in the top bar, now also the way to one's own account:
 * a key and the name on wider screens, just the key on a phone, where the
 * name never fitted anyway. Leads to "Change password".
 */
export function AccountMenuLink({ name }: { name: string }) {
  const { t } = useTranslation();
  return (
    <Link
      to="/account/password"
      title={t('account.menu.changePassword')}
      aria-label={t('account.menu.changePasswordFor', { name })}
      className="flex min-w-0 items-center gap-1.5 rounded-control p-2 text-sm text-content-secondary hover:bg-hover hover:text-content"
    >
      <KeyRound className="h-4 w-4 shrink-0" aria-hidden />
      <span className="hidden max-w-40 truncate sm:inline">{name}</span>
    </Link>
  );
}
